import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import RebootPopupContent from "./RebootPopupContent";
import HttpFetchStatus from "../../enums/api/http-fetch-status";
import SignalRConnectionState from "../../enums/api/signalr-connection-state";
import HttpError from "../../interfaces/api/http-error";


interface RebootPopupProps {
    isRebootStepInProgress: boolean;
    onRebootFinished: () => void;
    forceReboot?: boolean
    rebootData: {
        getStatus: { status: HttpFetchStatus; error: HttpError | null };
        postStatus: { status: HttpFetchStatus; error: HttpError | null };
        isRebootRequired: boolean;
    };
    hostHubConnectionStatus: SignalRConnectionState | null;
    updateTimeoutData: { length: number; startTime: number | null };
    onGetIsRebootRequired: () => void;
    onPostStartReboot: () => void;
}

const RebootPopup: React.FC<RebootPopupProps> = ({
    isRebootStepInProgress,
    onRebootFinished,
    forceReboot,
    rebootData,
    hostHubConnectionStatus,
    updateTimeoutData,
    onGetIsRebootRequired,
    onPostStartReboot
}) => {
    return (
        <React.Fragment>
            <Backdrop open={isRebootStepInProgress}>
                <Dialog open={isRebootStepInProgress} maxWidth="sm" fullWidth>
                    <DialogContent>
                        <Box width="100%">
                            <RebootPopupContent
                                onRebootFinished={onRebootFinished}
                                forceReboot={forceReboot}
                                rebootData={rebootData}
                                hostHubConnectionStatus={hostHubConnectionStatus}
                                updateTimeoutData={updateTimeoutData}
                                onGetIsRebootRequired={onGetIsRebootRequired}
                                onPostStartReboot={onPostStartReboot}
                            />
                        </Box>
                    </DialogContent>
                </Dialog>
            </Backdrop>
        </React.Fragment>
    );
};

export default RebootPopup;